module.exports = __webpack_public_path__ + "static/media/GalleryMain4.eaa154dc.jpg";